export class Config {
    FaviconPath!: string;
    LogoPath!: string;
    Theme!: string;
    GoogleAnalyticsKey!: string;
    ClientName!: string;
    WebRegionId!: number;
    BaseUrl!: string;
}
